module.exports = __webpack_public_path__ + "img/icon-differentials2_05.10c9fb11.svg";